const ADMIN = 'ROLE_ADMIN';
const OWNER = 'ROLE_OWNER';
const DIRECTOR = 'ROLE_DIRECTOR';
const FOREMAN = 'ROLE_FOREMAN';
const ESTIMATOR = 'ROLE_ESTIMATOR';
const WORKER = 'ROLE_WORKER';
const USER = 'ROLE_USER';
const SUPPORT = 'ROLE_SUPPORT';

const ROLE_PRIORITY = {
    [ADMIN]: 1000,
    [OWNER]: 100,
    [DIRECTOR]: 90,
    [FOREMAN]: 80,
    [ESTIMATOR]: 70,
    [WORKER]: 50,
    [USER]: 10,
    [SUPPORT]: 60,
};

// ЛУчше так делать
// const ROLES = {
//     ADMIN: {
//         name: 'Администратор',
//         priority: 1000,
//         maxRole: ADMIN
//     },
    
// }

const ROLE_NAMES = {
    [USER]: 'Пользователь',
    [SUPPORT]: 'Поддержка',
    [WORKER]: 'Работник',
    [FOREMAN]: 'Прораб',
    [DIRECTOR]: 'Руководитель',
    [ESTIMATOR]: 'Сметчик',
    [OWNER]: 'Владелец',
    [ADMIN]: 'Администратор'
};

export const isAdmin = () => {
    const roles = localStorage.getItem('roles');
    return roles && roles.includes(ADMIN);
}

export const formatRoleName = (role) => {
    return ROLE_NAMES[role] || role;
}

export const getMaxRole = (roles) => {
    let maxRole = null;
    let maxPriority = -1;

    if (!roles || roles.length === 0) return null;

    roles.forEach(role => {
        const priority = ROLE_PRIORITY[role] || 0;
        if (priority > maxPriority) {
            maxPriority = priority;
            maxRole = role;
        }
    });

    return maxRole;
}

export const checkRole = (userRole, requiredRole) => {
    const userPriority = ROLE_PRIORITY[userRole] || 0;
    const requiredPriority = ROLE_PRIORITY[requiredRole] || 0;

    return userPriority >= requiredPriority;
}

export const findRole = (userRoles, requiredRole) => {
    if (!userRoles) return false;
    return userRoles.includes(requiredRole);
}

export const getPriority = (role) => {
    return ROLE_PRIORITY[role] || 0;
}

export default {
    ADMIN,
    OWNER,
    DIRECTOR,
    FOREMAN,
    ESTIMATOR,
    WORKER,
    USER,
    isAdmin,
    formatRoleName,
    getMaxRole,
    checkRole,
    findRole
};
